import { observer } from 'mobx-react';
import { useEffect, useMemo, useState } from 'react';
import { DATE_YMD_ISO, DOWNLOAD_ATTENDANCE_HISTORY_TYPE, USER_TYPE } from '../../core/configs/constants';
import { useStore } from '../../core/utils/hook';
import Pagination from './components/Pagination';
import { handleDownloadFile } from '../../core/utils/file';
import moment from 'moment';
import { MutilCalendarCustom } from '../../components';
import EIAttendanceHistoryItem from './components/EIAttendanceHistoryItem';
import { toJS } from 'mobx';

function AttendanceHistoryEIScreen() {
    const [params, setParams] = useState({});
    const [range, setRange] = useState();

    const {
        authStore: { userInfo },
        apiStore: { showLoading, hideLoading },
        courseStore: {
            attendanceHistoriesEI, pagingAttendanceHistoryEI,
            getAttendanceHistoriesEI, cleanAttendanceHistoryEI
        },
        modalStore: { openErrorModal }
    } = useStore();

    useEffect(() => {
        handleSearch();
        return () => {
            cleanAttendanceHistoryEI();
        }
    }, [])

    useEffect(() => {
        console.log('attendanceHistories', toJS(attendanceHistoriesEI))
    }, [attendanceHistoriesEI])

    const fetchData = (init = {}) => {
        getAttendanceHistoriesEI({ ...params, ...init });
    }

    const handleSearch = () => {
        let fromDate = null, toDate = null;
        if (range?.[0]?.startDate && !isNaN(range?.[0]?.startDate) && range?.[0]?.endDate && !isNaN(range?.[0]?.endDate)) {
            fromDate = moment(range[0].startDate).format(DATE_YMD_ISO);
            toDate = moment(range[0].endDate).format(DATE_YMD_ISO);
        }

        setParams(prev => {
            return { ...prev, fromDate, toDate };
        })
        fetchData({ fromDate, toDate });
    }

    const handleChangeStatus = (key) => (event) => {
        const val = event.target.checked;
        setParams(prev => {
            let status = [...(prev.status || [])];
            if (val) {
                status.push(key);
            } else {
                status = status.filter(item => item !== key)
            }
            return { ...prev, status };
        })
    }

    const isHaveCourseCanCancelAttendance = useMemo(() => {
        return attendanceHistoriesEI.some(item => item.isCancelAttendance);
    }, [attendanceHistoriesEI])

    const handleAfterDownload = (msg) => {
        if (msg) {
            openErrorModal('エラー', msg);
        }
        hideLoading();
    }

    const handleExportSpecial = (courseId) => {
        const objDate = converParamDate();
        showLoading();
        handleDownloadFile({
            url: 'course/attendance/export-pdf',
            data: {
                typeExport: DOWNLOAD_ATTENDANCE_HISTORY_TYPE.SPECIAL, userIds: [userInfo?.id], courseIds: [courseId], searchByDate: {
                    fromDate: objDate.fromDate,
                    toDate: objDate.toDate
                }
            },
            cb: handleAfterDownload
        })
    }

    const onFetchData = (tableData = {}, picker = false) => {
        if (!tableData.fromDate && range?.[0]?.startDate && !picker) {
            const fromDate = moment(range[0].startDate).format(DATE_YMD_ISO)
            const toDate = moment(range[0].endDate).format(DATE_YMD_ISO)
            tableData.fromDate = fromDate;
            tableData.toDate = toDate;
        }
    };

    const handleChangeDate = (date) => {
        if (date.selection) {
            if (date.selection?.startDate && !isNaN(date.selection?.startDate) && date.selection?.endDate && !isNaN(date.selection?.endDate)) {
                const fromDate = moment(date.selection.startDate).format(DATE_YMD_ISO);
                const toDate = moment(date.selection.endDate).format(DATE_YMD_ISO);
                setRange(date.selection ? [date.selection] : undefined);
                onFetchData({ fromDate, toDate });
            } else {
                setRange(date.selection ? [date.selection] : undefined);
            }
        } else {
            setRange(date);
            onFetchData({}, true);
        }
    }

    const converParamDate = () => {
        let fromDate = null, toDate = null;
        if (range?.[0]?.startDate && !isNaN(range?.[0]?.startDate) && range?.[0]?.endDate && !isNaN(range?.[0]?.endDate)) {
            fromDate = moment(range[0].startDate).format(DATE_YMD_ISO);
            toDate = moment(range[0].endDate).format(DATE_YMD_ISO);
        }

        return { fromDate: fromDate, toDate: toDate };
    }

    if (!userInfo?.roleId || [USER_TYPE.GROUP_MANAGER].includes(userInfo?.roleId)) {
        return null;
    }

    return (
        <div id="main" className="wrapper main-student-list main-Attended-couse attendance-history attendance-history-screen">
            <div className="bres-cus">
                <div className="container">
                    <ul>
                        <li>
                            <a href="/">
                                <img src="/images/icon-home.svg" alt="" />
                            </a>
                        </li>
                        <li className="dash">\</li>
                        <li>
                            テスト履歴EI
                        </li>
                    </ul>
                </div>
            </div>
            <section className="top-student-list">
                <div className="container">
                    <div className="row">

                        <div className="col-12">
                            <div className="content-Attended-couse ">
                                {/* filter */}
                                <div className="content-top-student pd-tb-25">
                                    <div className='row'>
                                        <div className="col-md-12 col-sm-12 col-12">
                                            <div className='item item-22 custom-item-22 mg-b-15'>
                                                指定した期間中の受検履歴が確認できます
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12 col-sm-12 col-12 d-flex align-items-center">

                                            <div className='item item-22 custom-item-22 mg-t-0 ignore-css'>
                                                <div className='mg-r-15'>
                                                    <label htmlFor="" className='mg-t-10'>対象期間</label>
                                                </div>
                                                <div className='col-xl-10 col-12'>
                                                    <MutilCalendarCustom
                                                        ranges={range}
                                                        displayMode={'dateRange'}
                                                        onChange={handleChangeDate}
                                                        isEditInput={false}
                                                        isFirstDate={false}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-12 col-sm-12 col-12">
                                            <div className="item item-22 custom-item-22 mg-tb-0 d-flex align-items-center search-status">
                                                <label htmlFor="">ステータス</label>
                                                <ul className="list-check align-items-center pd-l-0">
                                                    <li className='li-1 min-width-120'>
                                                        <input id="st-1" type="checkbox" onChange={handleChangeStatus(1)} />
                                                        <label className='cursor-pointer' htmlFor='st-1'>受講中</label>
                                                    </li>
                                                    <li className='li-0 min-width-120'>
                                                        <input id="st-2" type="checkbox" onChange={handleChangeStatus(2)} />
                                                        <label className='cursor-pointer' htmlFor='st-2'>受講完了</label>
                                                    </li>
                                                    <input
                                                        type="submit"
                                                        className='submit-search'
                                                        style={{ marginLeft: 'auto' }}
                                                        value="検索" onClick={handleSearch} />
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <section className="content-student-list">
                                    <div className="row">
                                    </div>
                                    <div className="table-table">
                                        <table>
                                            <tr>
                                                <td>教材名</td>
                                                <td>受検ステータス</td>
                                                <td>受験完了日</td>
                                                <td>テスト結果</td>
                                                <td>単位申請状況</td>
                                                <td>認定種別</td>
                                            </tr>
                                            {
                                                (attendanceHistoriesEI || []).map((item, index) => {
                                                    return <EIAttendanceHistoryItem
                                                        key={index}
                                                        item={item}
                                                        fetchData={fetchData}
                                                    />
                                                })
                                            }
                                        </table>
                                        {!(attendanceHistoriesEI || []).length &&
                                            <div className='no-data w-100'>
                                                <p>データはありません</p>
                                            </div>
                                        }
                                    </div>
                                    <Pagination hideTotal paging={pagingAttendanceHistoryEI} onFetch={fetchData} />
                                </section>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default observer(AttendanceHistoryEIScreen);
